<template>
<div>
  <div class="d-print-none row">
      <div class="w-100 text-center mt-3">
         <h3>INVOICES</h3>
      </div>
      <div class="w-100 mb-3">
        <router-link to="/invoices/new-invoice" class="mr-3">
          POS
        </router-link>
        <router-link to="/invoices/companies" class="mr-3">
          Registered Clients
        </router-link>
<!--        <router-link to="/invoices/pending-invoices" class="mr-3">-->
<!--          Pending Invoices-->
<!--        </router-link>-->
        <router-link to="/invoices/reports">
          Invoice Reports
        </router-link>
      </div>
  </div>
  <router-view></router-view>
</div>

</template>

<script>
export default {
};
</script>

<style>
.router-link-active {
  color: #6c757d;
}
</style>
